import { render, staticRenderFns } from "./Privacy-Policy.vue?vue&type=template&id=21c32185&scoped=true&"
import script from "./Privacy-Policy.vue?vue&type=script&lang=js&"
export * from "./Privacy-Policy.vue?vue&type=script&lang=js&"
import style0 from "./Privacy-Policy.vue?vue&type=style&index=0&id=21c32185&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c32185",
  null
  
)

export default component.exports